import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import ProductVariant from "./product-variant.js";
import Stack from "./stack.js";
export default function ProductVariants(props) {
  const {articles, selectedVariantId, onChange, ...rest} = props;
  return /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, articles.map((article) => /* @__PURE__ */ React.createElement(ProductVariant, {
    key: article.id,
    selected: article.id === selectedVariantId,
    onClick: () => onChange && onChange(article.id),
    article,
    variant: article.variant
  })));
}
const Container = styled(Stack)`
  > div {
    cursor: pointer;
  }
`;
